export enum TiktokTokenStatus {
  RefreshTokenExpired = 'REFRESH_TOKEN_EXPIRED',
  TokenDoesNotExist = 'TOKEN_DOES_NOT_EXIST'
}
